<template>
  <v-container fluid py-0>
    <v-row no-gutters>
      <v-col cols="12">
        <Splitpanes class="default-theme">
          <Pane size="25" min-size="20" max-size="40">
            <v-row no-gutters>
              <v-col cols="12">
                <v-card height="calc(100vh - 48px - 16px)">
                  <v-radio-group
                    v-if="canSeeAnonRecords"
                    v-model="selectByAccount"
                    row
                    label="Selection type"
                    class="pt-4"
                  >
                    <v-radio
                      label="By Account"
                      @click="clearRecord()"
                      :value="true"
                    ></v-radio>
                    <v-radio
                      label="By Record"
                      @click="clearAccount()"
                      :value="false"
                    ></v-radio>
                  </v-radio-group>
                  <v-card-text class="record-navigator">
                    <span v-if="selectByAccount">
                      <v-card-title>
                        <span
                          style="font-size: 1.2em;"
                          class="font-weight-light"
                        >
                          Account Select
                        </span>
                      </v-card-title>
                      <v-card-actions>
                        <v-row justify="center">
                          <!-- ACCOUNT select -->
                          <v-form ref="accountform" v-model="valid">
                            <v-autocomplete
                              auto-select-first
                              :items="ACLS"
                              item-text="account_name"
                              item-value="account_name"
                              attach
                              clear-icon="mdi-close-circle"
                              clearable
                              @click:clear="clearSelectedAccount"
                              hide-selected
                              label="Select Account"
                              class="mx-6"
                              v-model="selectedAccount"
                              :search-input.sync="theAcc"
                              return-object
                              ref="accountSelect"
                              @change="submit"
                              full-width
                            >
                              <template
                                v-slot:selection="{ attr, on, item, selected }"
                              >
                                <v-chip
                                  v-bind="attr"
                                  :input-value="selected"
                                  color="#78909c"
                                  class="white--text"
                                  v-on="on"
                                >
                                  <v-icon left>mdi-coin</v-icon>
                                  <span v-text="item.account_name"></span>
                                </v-chip>
                              </template>
                            </v-autocomplete>
                          </v-form>
                        </v-row>
                      </v-card-actions>
                    </span>
                    <span v-if="!selectByAccount">
                      <v-card-title>
                        <span
                          style="font-size: 1.2em;"
                          class="font-weight-light"
                        >
                          Anonymous Records
                        </span>

                        <v-spacer></v-spacer>
                      </v-card-title>

                      <v-card-actions>
                        <v-row justify="center">
                          <!-- <v-btn
                          color="primary"
                          @click="addEncounter"
                          v-if="showChart && encounterMode"
                        >
                          <span>
                            hell <v-icon>{{ svgPlus }}</v-icon> Add Encounter
                          </span>
                        </v-btn> -->

                          <!-- Name select -->
                          <v-form ref="form" v-model="valid">
                            <v-autocomplete
                              append-outer-icon="mdi-plus"
                              @click:append-outer="showAddRecordDialog"
                              auto-select-first
                              :loading="!nodesLoaded"
                              :disabled="!nodesLoaded"
                              :items="records"
                              item-text="name"
                              item-value="_id"
                              attach
                              chips
                              clear-icon="mdi-close-circle"
                              clearable
                              @click:clear="clearSelectedRecord"
                              hide-selected
                              label="Select Record"
                              class="mx-6"
                              v-model="selectedRecord"
                              :search-input.sync="theRec"
                              return-object
                              ref="recordSelect"
                              @change="submit"
                              hint="These records are not associated with any user"
                              persistent-hint
                            >
                              <template
                                v-slot:selection="{ attr, on, item, selected }"
                              >
                                <v-chip
                                  v-bind="attr"
                                  :input-value="selected"
                                  color="#78909c"
                                  class="white--text"
                                  v-on="on"
                                >
                                  <v-icon left>mdi-coin</v-icon>
                                  <span v-text="item.name"></span>
                                </v-chip>
                              </template>
                            </v-autocomplete>
                          </v-form>
                        </v-row>
                      </v-card-actions>
                    </span>

                    <v-card-actions>
                      <v-btn
                        class="mr-4"
                        color="primary"
                        text
                        @click="editMode = !editMode"
                        v-if="showChart && !encounterMode"
                      >
                        <span v-if="editMode">
                          <v-icon>mdi-check</v-icon>
                        </span>
                        <span v-else>
                          <v-icon>mdi-pencil</v-icon>
                        </span>
                      </v-btn>

                      <v-text-field
                        v-if="searchBar"
                        autocomplete="off"
                        v-model="treeFilter"
                        prepend-icon="mdi-magnify"
                        label="Search"
                        clearable
                        class="mr-2"
                      ></v-text-field>
                    </v-card-actions>
                    <!-- <AudioCaptureWS v-if="editMode"></AudioCaptureWS> -->

                    <v-dialog v-model="showAddRecordDialogToggle" width="600px">
                      <v-slide-y-transition :hide-on-leave="true" mode="out-in">
                        <v-card v-if="showAddRecordCard">
                          <v-card-title>
                            <span class="font-weight-light">Add A Record</span>
                            <v-btn
                              icon
                              class="close-button elevation-0"
                              @click="cancelAddRecordDialog"
                            >
                              <v-icon>mdi-close-circle</v-icon>
                            </v-btn>
                            <v-spacer></v-spacer>
                          </v-card-title>
                          <v-divider></v-divider>
                          <v-card-text>
                            <p class="mt-3 mb-2">
                              Give the record a name and choose if it should be
                              a new, empty record or be based on a form you
                              select.
                            </p>
                            <v-form
                              ref="addRecordForm"
                              v-model="recordFormValid"
                            >
                              <v-text-field
                                autofocus
                                v-model="recordName"
                                label="Record name"
                                required
                                :rules="[
                                  v => !!v || 'Name is required',
                                  v =>
                                    !doesRecordNameExist(v) ||
                                    'That name already exists'
                                ]"
                              ></v-text-field>
                              <v-radio-group
                                v-model="recordType"
                                column
                                mandatory
                              >
                                <v-radio
                                  label="Empty record"
                                  value="normal"
                                ></v-radio>
                                <v-radio value="template">
                                  <template v-slot:label>
                                    From form
                                    <v-autocomplete
                                      :disabled="recordType !== 'template'"
                                      :items="templates"
                                      item-value="_id"
                                      return-object
                                      item-text="name"
                                      auto-select-first
                                      class="ml-2"
                                      v-model="templateData"
                                      :rules="[
                                        () =>
                                          !!templateData ||
                                          recordType === 'normal' ||
                                          'Form name is required'
                                      ]"
                                    ></v-autocomplete>
                                  </template>
                                </v-radio>
                              </v-radio-group>
                            </v-form>
                            <v-card-actions>
                              <v-btn
                                class="ml-auto"
                                :disabled="!recordFormValid"
                                color="info"
                                @click="addRecord"
                              >
                                <v-progress-circular
                                  v-if="isSubmitting"
                                  class="mr-3"
                                  indeterminate
                                  :size="20"
                                  :width="1"
                                  color="secondary"
                                ></v-progress-circular>
                                Create
                              </v-btn>
                            </v-card-actions>
                          </v-card-text>
                        </v-card>
                      </v-slide-y-transition>
                      <v-slide-y-transition mode="out-in">
                        <AddCategories
                          v-if="showAddCategories"
                          :categories="categories"
                          :selectedRecord="selectedRecord"
                          :nodeName="selectedRecord.name"
                          :nodeId="selectedRecord._id"
                          @cancel-add-dialog="cancelAddRecordDialog"
                          @close-add-dialog="cancelAddRecordDialog"
                        ></AddCategories>
                      </v-slide-y-transition>
                    </v-dialog>

                    <!-- Displays record -->
                    <div v-if="selectedRecord || CurrentlySelectedAccount">
                      <encounters
                        :treeFilter="filter"
                        :editMode="editMode"
                        :selectedRecord="treeViewRecord"
                      ></encounters>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </Pane>
          <Pane size="75">
            <v-row no-gutters class="pt-4">
              <v-col cols="12">
                <v-card height="calc(100vh - 48px - 16px)">
                  <RecordViewer v-if="RecordItem" />
                </v-card>
              </v-col>
            </v-row>
          </Pane>
        </Splitpanes>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
import Encounters from "./Encounters";
import RecordViewer from "./record-viewer/RecordViewer";
// import AudioCaptureWS from "./AudioCaptureWS";
import AddCategories from "./record-viewer/AddCategories.vue";
import { strings } from "vuex-store-builder";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";

export default {
  name: "Records",
  components: {
    Encounters,
    // AudioCaptureWS,
    RecordViewer,
    AddCategories,
    Splitpanes,
    Pane
  },
  watch: {
    // selectedRecord: function() {
    //   if (this.selectedRecord === null) {
    //     this.resetAllTabs();
    //     this.$store.dispatch("ResetAllRecords");
    //   }
    // },
    // treeViewRecord: function(currVal, prevVal) {
    //   if (prevVal !== currVal) {
    //     this.selectedRecord = this.treeViewRecord;
    //   }
    // },
    // CurrentlySelectedAccount: function(newVal) {
    //   this.selectedAccount = newVal;
    //   this.selectByAccount = true;
    // },
  },
  data() {
    return {
      theRec: null,
      theAcc: null,
      searchBar: false,
      selectedAccount: this.CurrentlySelectedAccount,
      selectedRecord: null,
      selectByAccount: true,
      treeFilter: "",
      editMode: false,
      encounterMode: false,
      name: null,
      errorMessagesName: "",
      valid: false,
      formHasErrors: false,
      showChart: false,
      templatesSelected: [],
      categoriesSelected: [],
      xsChart: 2,
      xsTree: 3,
      xsLine: 7,
      recordType: "normal",
      recordName: "",
      templateData: "",
      showAddRecordDialogToggle: false,
      showAddRecordCard: true,
      showAddCategories: false,
      recordFormValid: false,
      isSubmitting: false,
      unsubFn: null,
      roles: [],
      key: 0
    };
  },

  computed: {
    ...mapState("allRootNodes", { nodesLoaded: strings.loaded("nodes") }, ""),
    ...mapState({
      UserNotifications: state => state.records.UserRecordNotifications,
      currentRecordDateTimeStamp: state =>
        state.records.currentRecordDateTimeStamp,
      ACLS: state => state.app.recordsiamauthorizedon
    }),
    ...mapGetters({
      periodic: "getPeriodic",
      RecordItem: "getRecordItem",
      CurrentlySelectedAccount: "getCurrentlySelectedAccount",
      treeViewRecord: "getActiveRecord",
      userRoles: "getRoles"
    }),
    ...mapGetters("allTypes", { types: "list" }),
    ...mapGetters("allRootNodes", { records: "list" }),
    ...mapGetters("allTemplates", { templates: "list" }),
    ...mapGetters("allUoms", { uoms: "list" }),
    ...mapGetters("allRootCats", { categories: "list" }),

    RecordItemToBeDisplayed: function() {
      if (
        this.$store.state.records.currentlySelectedTab.recordId == undefined
      ) {
        return false;
      } else {
        return true;
      }
    },
    canSeeAnonRecords() {
      // The only roles that can't see anon records are 'member' and 'owner'
      // So we check if that is the *only* role this user has.
      this.key;
      if (!this.userRoles.length) {
        return false;
      }
      if (this.userRoles.includes("member") && this.userRoles.length === 1) {
        return false;
      }
      if (this.userRoles.includes("owner") && this.userRoles.length === 1) {
        return false;
      }
      if (this.userRoles === "member") {
        return false;
      }
      return true;
    },
    chartFlex() {
      return `xs${this.xsChart}`;
    },
    treeFlex() {
      return `xs${this.xsTree}`;
    },
    lineFlex() {
      return `xs${this.xsLine}`;
    },
    filter() {
      if (this.treeFilter) {
        return this.treeFilter.trim();
      } else {
        return this.treeFilter;
      }
    },
    form() {
      return {
        name: this.name
      };
    }
  },

  created() {
    this.$store.dispatch("allTypes/types");
    this.$store.dispatch("allRootNodes/nodes");
    this.$store.dispatch("allTemplates/templates");
    this.$store.dispatch("allUoms/uoms");
    this.$store.dispatch("allRootCats/cats");
    this.$store.dispatch("cdgGetAnalysisCats/getAnalysisCategories");
  },
  async mounted() {
    this.$root.$on("menu:reload-root-nodes", async () => {
      await this.$store.dispatch("allRootNodes/nodes");
      this.clear();
    });
    this.unsubFn = this.$store.subscribe(({ type, payload }, state) => {
      if (type === "UPDATE_ACTIVE_TAB_DATA") {
        // When an update is done to the root node, update the selectedRecord text
        if (
          payload.tabItemToUpdate.recordId ===
            payload.tabItemToUpdate.recordItemId &&
          this.selectedRecord?.name
        ) {
          this.selectedRecord.name = payload.recordToUpdate.name;
        }
      }
    });
    if (this.$route.query["record"]) {
      const id = this.$route.query["record"];
      this.selectedRecord = { _id: id };
      this.selectByAccount = false;
      this.submit();
      if (this.$route.query["event"]) {
        this.selectedRecord = await this.$store.dispatch("getRecord", id);
        this.viewEvent(this.$route.query["event"]);
      }
    }
    if (sessionStorage.getItem("userData")) {
      if (sessionStorage.getItem("userRoles")) {
        const res = sessionStorage.getItem("userRoles");
        this.roles = res.role || "member";
        this.key++;
      }
      if (this.ACLS.length === 0) {
        // If the ACL list hasn't yet been loaded and we have user data, go get it
        this.userData = await JSON.parse(sessionStorage.getItem("userData"));
        this.getAcls(this.userData.username);
      }
      if (this.onlyOneACL()) {
        // Only one ACL. Just load that record
        this.selectedAccount = this.ACLS[0];
        this.submit();
      }
    }
  },
  beforeUnmount() {
    // Unsubscribe from mutation notifications
    if (this.unsubFn) {
      this.unsubFn();
    }
  },
  methods: {
    ...mapActions(["openNewTab", "resetAllTabs", "getUser", "getAcls"]),
    async addRecord() {
      if (!this.recordFormValid) {
        return;
      }

      this.isSubmitting = true;
      if (this.recordType === "normal") {
        const data = {
          name: this.recordName,
          child_count: 0,
          children: [],
          meta: { type: "title" }
        };

        await this.$store.dispatch("postNewRecord/createRecord", data);
      } else {
        const params = {
          record_name: this.recordName,
          template_id: this.templateData._id
        };
        await this.$store.dispatch(
          "cloneRecordFromTemplate/createRecordFromTemplate",
          params
        );
      }

      await this.$store.dispatch("allRootNodes/nodes");
      const newRecord = find(this.records, { name: this.recordName });
      this.selectedRecord = newRecord;
      this.submit();
      this.isSubmitting = false;
      if (this.recordType !== "normal") {
        this.showAddRecordDialogToggle = false;
      } else {
        this.showAddRecordCard = false;
        this.showAddCategories = true;
      }
    },
    expand() {
      /*
      if(this.xsChart === 2) {
        this.xsChart = 3;
      } else {
        this.xsChart = 2;
      }

      if (this.xsTree === 10) {
        this.xsTree = 9;
      } else {
        this.xsTree = 10;
      }
      */
    },
    addEncounter() {},
    submit() {
      if (!this.selectByAccount && this.selectedRecord?._id) {
        this.searchBar = true;
        this.formHasErrors = false;
        this.showChart = false;

        Object.keys(this.form).forEach(f => {
          if (!this.form[f]) {
            this.formHasErrors = true;
          }
          if (this.$refs[f]) {
            this.$refs[f].validate(true);
          }
        });
        if (this.valid) {
          this.showChart = true;
          if (this.selectedRecord?._id) {
            /*
            this.$store.dispatch(
              "cdgGetStateId/getStateId",
              this.selectedRecord._id
            );
            */
            this.$store.dispatch("getRecord", this.selectedRecord._id);
            // this.$store.dispatch("getNotifications", this.selectedRecord._id);
            // if (this.UserNotifications.length > 0) {
            //   this.$store.dispatch("addNotification", {
            //     type: "success",
            //     message: `You Have Notifications`,
            //   });
            // }
          }
        }
      }
      if (this.selectByAccount) {
        if (this.selectedAccount) {
          this.$store
            .dispatch("selectAccount", this.selectedAccount.account_name)
            .then(res => {
              if (res && !res.Error) {
                this.selectedRecord = res;
              }
            });
        } else {
          this.clearSelectedAccount();
        }
      }
    },
    clear() {
      this.searchBar = false;
      this.showChart = false;
      this.selectedRecord = null;
      this.selectedAccount = null;
    },
    clearSelectedRecord() {
      this.$store.dispatch("resetAllTabs");
      this.clear();
    },
    clearSelectedAccount() {
      this.$store.dispatch("selectAccount", null);
      this.clear();
    },
    doesRecordNameExist(name) {
      return findIndex(this.records, { name: name }) !== -1;
    },
    showAddRecordDialog() {
      this.showAddRecordDialogToggle = true;
      Vue.nextTick(() => {
        this.$refs.addRecordForm.reset();
      });
    },
    cancelAddRecordDialog() {
      this.showAddCategories = false;
      this.showAddRecordCard = true;
      this.showAddRecordDialogToggle = false;
    },
    viewEvent(event) {
      const fakeRecordItem = {
        name: `Event ${event}`,
        _id: this.selectedRecord._id
      };
      this.openNewTab({
        recordItem: fakeRecordItem,
        fullRecord: this.selectedRecord,
        type: "event",
        datetime: this.currentRecordDateTimeStamp,
        typeSpecificPayload: event
      });
    },

    onlyOneACL() {
      return this.ACLS.length === 1;
    },
    clearRecord() {
      if (this.selectedRecord) {
        this.clear();
        this.$store.dispatch("ResetAllRecords");
        this.selectedRecord = null;
      }
    },
    clearAccount() {
      if (this.selectedRecord) {
        this.clear();
        this.$store.dispatch("ResetAllRecords");
        this.selectedRecord = null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.record-navigator {
  // height: 90vh;
  height: calc(90vh - 48px - 16px);
  padding: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
form {
  width: 100%;
}
.close-button {
  position: absolute;
  right: 0px;
  cursor: pointer;
  z-index: 200;
  margin-top: -20px;
}
.default-theme {
  .splitpanes__pane {
    background-color: #fff;
  }
}
</style>
<style lang="scss">
.default-theme.splitpanes--vertical > .splitpanes__splitter {
  width: 10px;
  border-left: 1px solid #eee;
  border-right: 1px solid #eee;
  border-radius: 11%;

  &::before,
  &::after {
    height: 40px;
    background-color: #90caf9;
    &:hover {
      background-color: #42a5f5;
    }
  }
}
.v-input--radio-group__input legend {
  width: 100%;
  padding-bottom: 5px;
}
</style>
